var PixelEventTopic = /* @__PURE__ */ ((PixelEventTopic2) => {
  PixelEventTopic2["Frames"] = "frames";
  PixelEventTopic2["App"] = "app";
  PixelEventTopic2["Session"] = "session";
  PixelEventTopic2["Tracking"] = "tracking";
  PixelEventTopic2["Script"] = "script";
  PixelEventTopic2["Embedded"] = "embedded";
  PixelEventTopic2["Native"] = "native";
  PixelEventTopic2["Profile"] = "profile";
  return PixelEventTopic2;
})(PixelEventTopic || {});

export { PixelEventTopic };
